import { PENGALI_USIA, REKOMENDASI_PRODUK } from './constants';

export const getFaktorPengali = (usia) => {
  const range = PENGALI_USIA.find(r => usia >= r.min && usia <= r.max);
  return range ? range.faktor : 8;
};

export const hitungIncomeBased = (penghasilan, usia, persentaseProteksi = 80) => {
  const faktor = getFaktorPengali(usia);
  const proteksiPerBulan = (penghasilan * persentaseProteksi) / 100;
  return proteksiPerBulan * 12 * faktor;
};

export const hitungNeedBased = (data) => {
  const {
    pengeluaranBulanan,
    persentasePengeluaran = 70,
    lamaKebutuhan = 15,
    danaMasaDepan,
    totalKewajiban,
    totalAset
  } = data;

  // Step 1: Dana Penghasilan Pengganti
  const pengeluaranDicover = (pengeluaranBulanan * persentasePengeluaran) / 100;
  const danaPengganti = pengeluaranDicover * 12 * lamaKebutuhan;

  // Step 2-4: Total Kebutuhan
  const totalKebutuhan = danaPengganti + danaMasaDepan + totalKewajiban;

  // Step 5: Kurangi Aset
  const kebutuhanFinal = totalKebutuhan - totalAset;

  return Math.max(0, kebutuhanFinal);
};

export const getRekomendasiProduk = (usia) => {
  const rekomendasi = REKOMENDASI_PRODUK.find(r => usia >= r.minUsia && usia <= r.maxUsia);
  return rekomendasi ? rekomendasi.produk : 'Konsultasi dengan Perencana Keuangan';
};

export const estimasiPremi = (usia, uangPertanggungan) => {
  // Sederhanakan: asumsi premi 0.3% dari UP untuk usia muda, 0.8% untuk usia tua
  if (usia <= 35) return uangPertanggungan * 0.003;
  if (usia <= 45) return uangPertanggungan * 0.005;
  return uangPertanggungan * 0.008;
};